/**
 * Links between console pages keep the page's own query string
 * (docs/DECISIONS.md ZD-124 §2).
 *
 * The source — `?api=`, `?fixture`, and under `dev-header` the identity claims
 * `?tenant=`, `?user=`, `?role=` — lives in the URL (`sourceFromLocation`), so
 * a link that dropped it would sign a local developer out on the first click
 * and point a `?api=` page back at its own origin. Only `assessment` is set or
 * cleared; everything else travels as it was. Nothing is added: a credential
 * never appears in a URL, and the claims that do are the ones the person put
 * there.
 */
export function hrefFor(search: string, assessmentId: string | null): string {
  const params = new URLSearchParams(search);
  if (assessmentId === null) params.delete('assessment');
  else params.set('assessment', assessmentId);
  const query = params.toString();
  return query.length === 0 ? '/' : `/?${query}`;
}
